module.exports = __webpack_public_path__ + "static/media/about-background.04a6d573.png";